import { render, staticRenderFns } from "./FollowItem.vue?vue&type=template&id=0b024990&scoped=true&"
import script from "./FollowItem.vue?vue&type=script&lang=js&"
export * from "./FollowItem.vue?vue&type=script&lang=js&"
import style0 from "./FollowItem.vue?vue&type=style&index=0&id=0b024990&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b024990",
  null
  
)

export default component.exports